import { styled } from '@mui/material/styles';

export const StyledBulkPlaceholderDiv = styled('div')<{
  height: number;
}>`
  display: flex;

  height: ${({ height }) => height}px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-top: none;
  padding-left: ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(1)};
`;
